import SidebarBookingsPriceEditController from 'uplisting-frontend/pods/-sidebar/bookings/price/edit/controller';

export default class ProtectionOverviewBookingsPriceEditController extends SidebarBookingsPriceEditController {}
